import React from 'react';
import { Col } from 'reactstrap';
import i18n from '../i18next';

import MenuuLogoSVG from '../images/MenuuLogoSVG';
import loginScreenImg from '../images/Login-BG.jpg';

const LoginScreenLeftSide = () => {
    const { mainCol, logoSvg, textCol, leftSideH, lastParagraph } = styles;
    return (
        <Col className='d-xs-none' md={5} style={mainCol}>
            <a href='https://menuu.com' id='logo' className='logInLogo'>
                <MenuuLogoSVG width={150} height={150} fill={'#fff'} style={logoSvg} />
            </a>
            <div className='textCol' style={textCol}>
                <h1 id='leftSideH' style={leftSideH}>{i18n.t('screens:loginScreen.leftSideH')}</h1>
                <p style={lastParagraph}>{i18n.t('screens:loginScreen.lastParagraph')}</p>
            </div>
        </Col>
    );
}

export default LoginScreenLeftSide;

let styles = {
    mainCol: {
        paddingRight: 0,
        backgroundImage: `url(${loginScreenImg})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center right',
        fontFamily: 'neue-haas-grotesk-display, sans-serif',
        fontStyle: 'normal',
        fontWeight: 100
    },
    logoSvg: {
        position: 'absolute',
        top: 10,
        left: 30
    },
    textCol: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignSelf: 'center',
        padding: '0 14%',
        height: '100%',
        color: '#fff'
    },
    leftSideH: {
        fontSize: 34,
        paddingBottom: 10,
        marginTop: 0,
        fontWeight: 600,
        lineHeight: '37px'
    },
    lastParagraph: {
        fontSize: 17,
        paddingBottom: 10,
        lineHeight: '24px'
    }
}


// WEBPACK FOOTER //
// ./src/components/LoginScreenLeftSide.js